import { Alert, Col, Container, Form, Row } from 'react-bootstrap';
import Input from '../../views/input/input';
import Text from '../../views/text/text';
import Title from '../../views/title/title';
import Button from '../../views/button/button';
import './RegisterForm.css'
import DemoImage from './images/subscription_registration.png'; 
import { useState } from 'react';
import validator from '../../core/utils/validators';
import AxiosClient from '../../core/rest/client';
import { useNavigate } from 'react-router-dom';
import Progress from '../progress/progress';
import ResultDialog from '../../views/result-dialog/result-dialog';
import toast from 'react-hot-toast';
import gtag from '../../core/utils/gtag';
import AddressAutocomplete from '../../views/autocomplete/autocomplete';
import extractAddressParts from '../../core/utils/addresssExtracter';
import { US_STATES } from '../../core/data/states';

const WM_TYPES = ["CLEANING", "SECURITY", "LANDSCAPING", "OTHER_HOME"];

function RegisterForm() {

    let navigate = useNavigate();

    const priceTier = new URLSearchParams(window.location.search).get("t");
    const [isAgreedToTnC, setIsAgreedToTnC] = useState(false);
    const [inputVals, setInputVals] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        orgName: '',
        orgType: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        taxId: '',
        websiteUrl: '',
        promoCode: '',
        tier: priceTier
    });

    const [errorState, setErrorState] = useState({
        firstName: false,
        lastName: false,
        email: false,
        phone: false,
        orgName: false,
        orgType: false,
        taxId: false,
        address2: false,
        address1: false,
        city: false,
        state: false,
        websiteUrl: false,
        promoCode: false,
        zipCode: false
    });

    const [showError, setShowError] = useState(false);
    const [isInSubmitProgress, setIsInSubmitProgress] = useState(false);

    const demoSubmitFunction = () => {

        if(isInSubmitProgress)
            return;

        for (var key in inputVals) {
            if (key === 'firstName' || key === 'lastName') {
                errorState[key] = !validator['name'](inputVals[key]);
            } else if (key === 'email') {
                errorState[key] = !validator['email'](inputVals[key]);
            } else if (key === 'phone') {
                errorState[key] = !validator['phone'](inputVals[key]);
            } else if (key === 'orgName') {
                errorState[key] = !validator['value'](inputVals[key]);
            } else if (key === 'taxId') {
                errorState[key] = !validator['value'](inputVals[key]);
            } else if (key === 'address1') {
                errorState[key] = !validator['value'](inputVals[key]);
            } else if (key === 'city') {
                errorState[key] = !validator['value'](inputVals[key]);
            } else if (key === 'state') {
                errorState[key] = !validator['value'](inputVals[key]);
            } else if (key === 'zipCode') {
                errorState[key] = !validator['zip'](inputVals[key]);
            } else if (key === 'orgType') {
                errorState[key] = inputVals[key] === '';
            }
        }

        inputVals.orgType = WM_TYPES.includes(inputVals.orgType) ? 'WM' : inputVals.orgType;

        setErrorState({
            ...errorState
        });

        if (!isAgreedToTnC) {
            return;
        }
        
        for (key in errorState) {
            if (errorState[key]) {
                return;
            }
        }

        inputVals.promoCode = inputVals.promoCode.trim();

        setIsInSubmitProgress(true);

        let axiosClient = new AxiosClient();
        axiosClient.postRequest(process.env.REACT_APP_API_URL +"/payments", inputVals, onSubmissionSuccess, onSubmissionFailure);
    };

    const onSubmissionSuccess = (response) => {
        setInputVals({
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            orgName: '',
            orgType: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipCode: '',
            taxId: '',
            websiteUrl: '',
            promoCode: ''
        });
        setIsInSubmitProgress(false);
        
        if (response.data === undefined) {
            setShowError(true);
            toast.error("Failed to complete the registration");
            return;
        }

        const paymentSecret = response.data.key;
        const paymentAmount = response.data.paymentAmount;
        gtag.event('registration_successful');
        navigate('/register/payment', { state: {
            clientSecret: paymentSecret,
            payAmount: paymentAmount,
            discountAmount: response.data.discountAmount
        }});
    };

    const onSubmissionFailure = (error) => {
        const status = error.response ? error.response.status : undefined;
        const code = error.response && error.response.data ? error.response.data.code : undefined;

        if (status === 400 && code === 'INVALID_PROMO_CODE') {
            setIsInSubmitProgress(false);
            errorState.promoCode = true;
            setErrorState({
                ...errorState
            });
            toast.error("The promotional code is not valid");
            return;
        }

        setShowError(true);
        setInputVals({
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            orgName: '',
            orgType: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipCode: '',
            taxId: '',
            websiteUrl: '',
            promoCode: ''
        });
        setIsInSubmitProgress(false);
        gtag.event('registration_failed');
        toast.error("Failed to complete the registration");
    };

    const changeHandler = (e) => {
        inputVals[e.target.name] = e.target.value;
        if(errorState[e.target.name] !== undefined) {
            errorState[e.target.name] = false;
            setErrorState({ 
                ...errorState
            });
        }
    };

    const validateFn = (e) => {
        errorState[e.target.name] = !validator[e.target.attributes['data-validation-type'].value](e.target.value);
        setErrorState({ 
            ...errorState
        });
    };

    return (
        <>
            <Container className="demo-container">
                <Row>
                    <section><Title>Let's get started with Ontime<strong>Register Now!</strong></Title></section>
                </Row>
                <Row className="demo-form-container">
                    <Col sm="5">
                        <Row>
                        { showError &&
                            <Alert  variant="danger">
                                Oh snap! You got an error!
                            </Alert>
                        }
                        </Row>
                        <Row>
                            <section><Text>Your Name</Text></section>
                        </Row>
                        <Row className="demo-form-row">
                            <Col sm="12" lg="6">
                                <Input placeholder="First Name" type="text" onChange={changeHandler} onBlur={validateFn}
                                        name="firstName" errormessage="Please enter a valid First Name"
                                        showerror={+errorState.firstName} data-validation-type="name" value={inputVals.firstName}></Input>
                            </Col>
                            <Col sm="12" lg="6" className="mt-2 mt-lg-0">
                                <Input placeholder="Last Name" type="text" onChange={changeHandler} onBlur={validateFn}
                                        name="lastName" errormessage="Please enter a valid Last Name"
                                        showerror={+errorState.lastName} data-validation-type="name" value={inputVals.lastName}></Input>
                            </Col>
                        </Row>
                        <Row className="demo-form-row">
                            <section><Text>Billing Address</Text></section>
                        </Row>
                        <Row className="demo-form-row">
                            <Col sm="12">
                                <Input placeholder="Email Address" type="email" onChange={changeHandler} onBlur={validateFn}
                                        name="email" errormessage="Please enter valid Email address" 
                                        showerror={+errorState.email} data-validation-type="email" value={inputVals.email}></Input>
                                </Col>
                            <Col sm="12" className="extra-margin">
                                <Input placeholder="Phone Number" type="telephone" onChange={changeHandler} onBlur={validateFn}
                                        name="phone" errormessage="Please enter a valid Phone Number" 
                                        showerror={+errorState.phone} data-validation-type="phone" value={inputVals.phone} maxLength="10"></Input>
                            </Col>
                            <Col sm="12" className="extra-margin">
                                <AddressAutocomplete
                                    onSelect={({ formattedAddress, addressComponents }) => {
                                        const segments = extractAddressParts(addressComponents);

                                        const searchedAddressSegments = formattedAddress?.split(',');
                                        const city = (segments.city?.trim() || segments.sublocality?.trim() || segments.county?.trim() || '');
                                        const cityIndex = searchedAddressSegments.findIndex(item => item.trim() === city);
                                        if (cityIndex > 0) {
                                            segments.address1 = searchedAddressSegments?.slice(0, cityIndex).join(', ');
                                        } else {
                                            segments.address1 = searchedAddressSegments.slice(0, -3).join(', ');
                                        }

                                        segments.state = US_STATES.find(state => state.code === segments.state)?.code || '';

                                        setInputVals(prev => ({
                                            ...prev,
                                            address1: segments.address1,
                                            city:
                                                segments.city ||
                                                segments.sublocality ||
                                                segments.county,
                                            state: segments.state,
                                            zipCode: segments.postalCode,
                                        }));
                                    }}
                                />
                            </Col>
                            <Col sm="12" className="extra-margin">
                                <Input placeholder="Address Line 1" type="text" onChange={changeHandler} onBlur={validateFn}
                                        name="address1" errormessage="Please enter a valid Address Line" 
                                        showerror={+errorState.address1} data-validation-type="value" value={inputVals.address1}></Input>
                            </Col>
                            <Col sm="12" className="extra-margin">
                                <Input placeholder="Address Line 2" type="text" onChange={changeHandler} 
                                        name="address2"
                                        value={inputVals.address2}></Input>
                            </Col>
                            <Col sm="12" className="extra-margin">
                                <Input placeholder="City" type="text" onChange={changeHandler} onBlur={validateFn}
                                        name="city" errormessage="Please enter a valid City" 
                                        showerror={+errorState.city} data-validation-type="value" value={inputVals.city}></Input>
                            </Col>
                            <Col sm="12" className="extra-margin">
                                <Form.Select size="lg" onChange={changeHandler} name="state" value={inputVals.state} isInvalid={errorState.state}>
                                    <option value="">Select State</option>
                                    {US_STATES.map((state) => (
                                        <option key={state.code} value={state.code}>{state.name}</option>
                                    ))}
                                        
                                 </Form.Select>
                            </Col>
                            <Col sm="12" className="extra-margin">
                                <Input placeholder="Zip Code" type="text" onChange={changeHandler} onBlur={validateFn}
                                        name="zipCode" errormessage="Please enter a valid Zip Code" 
                                        showerror={+errorState.zipCode} data-validation-type="zip" value={inputVals.zipCode} maxLength="5"></Input>
                            </Col>
                        </Row>
                        <Row className="demo-form-row">
                            <section><Text>Organization Information</Text></section>
                        </Row>
                        <Row className="demo-form-row">
                            <Col sm="12">
                                <Input placeholder="Organization Name" type="text" onChange={changeHandler} onBlur={validateFn}
                                        name="orgName" errormessage="Please enter your Organization Name"
                                    showerror={+errorState.orgName} data-validation-type="orgname" value={inputVals.orgName}></Input>
                            </Col>
                            <Col sm="12" className="extra-margin">
                                <Input placeholder="EIN /Tax Id Number" type="text" onChange={changeHandler} onBlur={validateFn}
                                        name="taxId" errormessage="Please enter Tax Id Number without special characters"
                                        showerror={+errorState.taxId} data-validation-type="text" value={inputVals.taxId}></Input>
                            </Col>
                            <Col sm="12"className="extra-margin">
                                <Input placeholder="Website URL" type="text" onChange={changeHandler} 
                                        name="websiteUrl"
                                        value={inputVals.websiteUrl}></Input>
                            </Col>
                            <Col sm="12" className="extra-margin">
                                <Form.Select size="lg" onChange={changeHandler} name="orgType" isInvalid={errorState.orgType} value={inputVals.orgType}>
                                    <option value="">Select Org Type</option>
                                    <option value="HSA">Healthcare Staffing Agency</option>
                                    <option value="SADC">Social Adult Day Care Center</option>
                                    <option value="HHA">Home Healthcare Agency </option>
                                    <option value="CLEANING">Cleaning Service</option>
                                    <option value="SECURITY">Private Security Company</option>
                                    <option value="LANDSCAPING">Landscaping & Grounds Services</option>
                                    <option value="OTHER_HOME">Other Home Services Company</option>
                                </Form.Select>
                            </Col>
                            <Col sm="12" className="extra-margin promo-container">
                                <Input placeholder="Promotion code (optional)" type="text" onChange={changeHandler}
                                        name="promoCode" className="promo-input" maxLength="32"
                                        errormessage="This promotion code is not valid. Remove it or try another one"
                                        showerror={+errorState.promoCode} value={inputVals.promoCode}></Input>
                            </Col>

                            <Col sm="12" className="extra-margin tnc-container">
                                <br />
                                <input type="checkbox" className="checkbox" id="termscond" name="termscond" checked={isAgreedToTnC} onChange={(e) => setIsAgreedToTnC(e.target.checked)} />
                                <label className='termsnconditions' htmlFor="termscond">I've read and I agree to the  <a target="_blank" href='/ontime-ua.pdf' rel="noopener noreferrer">Terms and Conditions</a></label>
                            </Col>
                        </Row>
                        <Row className="demo-form-row">
                            <Col>
                                <Button className="float-lg-end" disabled={!isAgreedToTnC} large onClick={ demoSubmitFunction }>Submit</Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm="5" className='imageSection'>
                        <img src={DemoImage} alt="demo"></img>  
                    </Col>
                </Row>
                <ResultDialog></ResultDialog>
            </Container>
            <Progress show = {isInSubmitProgress}></Progress>
        </>
    );
}

export default RegisterForm;